<div class="mt-3 flex flex-col gap-3 xs:flex-row">
  <div class="flex flex-col gap-2.5">
    <lib-sign-box
      (blobCreated)="onSignChange($event)"
      (isSigned)="onSigned($event)"
      [ngClass]="{
        '!border-states-red': vm().isFormSubmitted && vm().signBlob === null,
        '!border-text-extra-light !bg-background-disabled': !!imageUrl || isDragging()
      }"
      [isDisabled]="!!imageUrl || isDragging()"
    />
    @if (vm().isFormSubmitted && vm().signBlob === null) {
      <div class="typo-h7-light text-states-deep-red">
        {{ 'site_setup_form_required_sign' | translate }}
      </div>
    }
    <div class="typo-h7-light text-text-tertiary">
      {{ 'site_setup_contract_sign_instructions' | translate }}
    </div>
  </div>

  <div class="flex items-center justify-center">
    <p class="typo-h7-semibold text-text-light xs:mb-[28px]">{{ 'site_setup_contract_or' | translate }}</p>
  </div>

  <div class="flex flex-col gap-2.5">
    <input #imageUploader class="hidden" type="file" (change)="onUpload($event)" [accept]="acceptedMimeTypes" />

    <button
      class="relative flex h-[120px] flex-col items-center justify-center gap-2 rounded-3xl border border-primary-blue p-2.5 text-primary-blue disabled:border-text-extra-light disabled:text-text-extra-light"
      [ngClass]="{ 'border-states-red': vm().isFormSubmitted && vm().signBlob === null, 'bg-background-light-blue': isDragging() }"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="onUploadClick()"
      type="button"
      [disabled]="isSigned"
    >
      @if (imageUrl !== null) {
        <div [libPreviewImage]="imageUrl" class="h-full w-full">
          <img crossorigin="anonymous" class="h-full w-full rounded-2xl object-contain" [src]="imageUrl" />
          <button type="button" class="typo-h4-semibold absolute right-3 top-2 text-primary-blue" (click)="onClearClick($event)">
            {{ 'charting_treatment_plan_review_treatment_review_sign_clear' | translate }}
          </button>
        </div>
      } @else {
        <svg-icon class="shrink-0" size="md" key="px-24-upload"></svg-icon>
        <p class="typo-h4-semibold">{{ 'site_setup_contract_upload_file' | translate }}</p>
      }
    </button>
    <div class="typo-h7-light text-text-tertiary">{{ 'site_setup_contract_browse_or_drag' | translate }}</div>
  </div>
</div>
